import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

export default function PaymentCancelPage() {
    const { setIsOpen } = useCart();
    const { t } = useLanguage();

    return (
        <main className="pt-16 md:pt-20 min-h-screen flex items-center justify-center px-5" data-testid="payment-cancel-page">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="text-center max-w-md"
            >
                <h1 className="font-display text-3xl md:text-4xl font-bold uppercase tracking-tight" data-testid="payment-cancel-title">
                    {t("payment.cancelTitle")}
                </h1>
                <p className="mt-4 text-sm text-zinc-500 leading-relaxed">
                    {t("payment.cancelBody")}
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <button
                        onClick={() => setIsOpen(true)}
                        data-testid="payment-cancel-reopen-cart"
                        className="bg-black text-white px-8 py-4 text-xs tracking-[0.25em] uppercase font-semibold transition-colors duration-300 hover:bg-zinc-800"
                    >
                        {t("payment.backToCart")}
                    </button>
                    <Link
                        to="/shop"
                        data-testid="payment-cancel-shop"
                        className="group inline-flex items-center gap-3 border border-black px-8 py-4 text-xs tracking-[0.25em] uppercase font-semibold transition-colors duration-300 hover:bg-black hover:text-white"
                    >
                        <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
                        {t("payment.shop")}
                    </Link>
                </div>
            </motion.div>
        </main>
    );
}
